"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceCallTypeEnum = void 0;
var VoiceCallTypeEnum;
(function (VoiceCallTypeEnum) {
    VoiceCallTypeEnum["UNKNOWN"] = "UNKNOWN";
    VoiceCallTypeEnum["PREMIUM_RATE"] = "PREMIUM_RATE";
    VoiceCallTypeEnum["TOLL_FREE"] = "TOLL_FREE";
    VoiceCallTypeEnum["SHARED_COST"] = "SHARED_COST";
    VoiceCallTypeEnum["FIXED_LINE_OR_MOBILE"] = "FIXED_LINE_OR_MOBILE";
    VoiceCallTypeEnum["FIXED_LINE"] = "FIXED_LINE";
    VoiceCallTypeEnum["MOBILE"] = "MOBILE";
    VoiceCallTypeEnum["INTERNAL"] = "INTERNAL";
    VoiceCallTypeEnum["INBOUND"] = "INBOUND";
    VoiceCallTypeEnum["VOIP"] = "VOIP";
})(VoiceCallTypeEnum = exports.VoiceCallTypeEnum || (exports.VoiceCallTypeEnum = {}));
